class UploadManager {
  uploads: Record<string, any> = {};
  listeners: Record<string, Function[]> = {};

  start(uploadId: string, task: any) {
    this.uploads[uploadId] = task;
  }

  get(uploadId: string) {
    return this.uploads[uploadId];
  }

  remove(uploadId: string) {
    delete this.uploads[uploadId];
    delete this.listeners[uploadId];
  }

  subscribe(uploadId: string, cb: Function) { 
  if (!this.listeners[uploadId]) {
    this.listeners[uploadId] = [];
  } 
  this.listeners[uploadId].push(cb);

  // devolver función unsubscribe
  return () => {
    this.listeners[uploadId] =
      this.listeners[uploadId]?.filter(listener => listener !== cb);
  };
}

  emit(uploadId: string, data: any) {
    if (!this.listeners[uploadId]) return;
    this.listeners[uploadId].forEach((cb) => cb(data));
  }
}

export const uploadManager = new UploadManager();